import {h, Fragment} from "preact"
import { closeSearchHeader } from '../../helpers.js'
export default function SubmitButton({ text }) {
    return (
        <div class="ns-autocomplete-submit">
            <button
                type="submit"
                onClick={() => {
                    closeSearchHeader()
                }}>
                {text}
            </button>
        </div>
    )
}
